var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text",class:{ [`text--size--${_vm.size}`]: _vm.size, [`text--color--${_vm.color}`]: _vm.color, 'text--disabled': _vm.disabled, 'text--pointer': _vm.pointer, 'text--inline': _vm.inline }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }